import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {StripeAddCardComponent} from './stripe-add-card.component';
import {CommonModule} from '@angular/common';
import {ButtonModule} from '@ucx/ui-cmp';
import {NgxStripeModule} from 'ngx-stripe';
import {ConfirmModalModule} from '../../../shared/modules/confirm-modal/confirm-modal.module';

@NgModule({
    declarations: [
        StripeAddCardComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule,
        ButtonModule,
        NgxStripeModule,
        ConfirmModalModule
    ],
    providers: [],
    exports: [
        StripeAddCardComponent
    ]
})

export class StripeAddCardModule {
}
